export const getSocialMediaLabel = (link: string) => {
  const lowercase = link.toLocaleLowerCase();
  const socialMediaMap = {
    instagram: 'Instagram',
    'x/twitter': 'Twitter',
    tikTok: 'TikTok',
  };

  if (lowercase.includes('instagram.com')) {
    return socialMediaMap.instagram;
  }
  if (lowercase.includes('x.com')) {
    return socialMediaMap['x/twitter'];
  }
  if (lowercase.includes('twitter.com')) {
    return socialMediaMap['x/twitter'];
  }
  if (lowercase.includes('tiktok.com')) {
    return socialMediaMap.tikTok;
  }
  return '';
};
